exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reset-password a {\n  color: #fff;\n  text-decoration: underline;\n}", ""]);

